<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nz-resizable
    [nzWidth]="siderWidth"
    [nzMinWidth]="80"
    [nzMaxWidth]="550"
    [nzCollapsed]="effectiveCollapsed"
    (mouseenter)="onMouseEnterSidebar()"
    (mouseleave)="onMouseLeaveSidebar()"
    (nzResize)="onSideResize($event)"
  >
    <nz-resize-handle nzDirection="right" nzCursorType="grid">
      <div class="sider-resize-line"></div>
    </nz-resize-handle>
    <!-- Logo for expanded state -->
    <div class="sidebar-logo" *ngIf="!isCollapsed">
      <a routerLink="">
        <img class="logo" [src]="logoPath" [style]="expandedLogoStyle" alt="Logo" />
      </a>
    </div>
    <!-- Logo for collapsed state -->
    <div class="sidebar-logo-collapsed" *ngIf="isCollapsed">
      <a routerLink="">
        <img class="logo" [src]="collapsedLogoPath" [style]="collapsedLogoStyle" alt="Collapsed Logo" />
      </a>
    </div>
    <!-- Previous sider content remains the same -->

    <!-- Add the admin menu -->
    @if (visibleAdminMenuItems.length) {
      <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-submenu nzTitle="Administration" nzIcon="dashboard" [nzOpen]="true">
          <ul>
            @for (item of visibleAdminMenuItems; track item.link) {
              <li nz-menu-item nzMatchRouter>
                <a [routerLink]="item.link">
                  <span nz-icon [nzType]="item.icon"></span>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      </ul>
    }

    <app-view-menu></app-view-menu>
  </nz-sider>

  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>

        <app-view-search-table></app-view-search-table>
        <!-- <div class="header-search">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input
              nz-input
              placeholder="Search tables..."
              [(ngModel)]="searchTerm"
              (input)="onSearch()"
              (keydown.enter)="handleEnterKey($event)"
              [nzAutocomplete]="auto"
            />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span nz-icon nzType="search"></span>
          </ng-template>
          <nz-autocomplete #auto>
            <nz-auto-option
              *ngFor="let option of filteredTables"
              [nzValue]="option.title"
              [nzLabel]="option.title"
            >
              <div class="search-result-item">
                <div class="table-name" (click)="navigateToTable(option)">
                  {{ option.title }}
                </div>
                <div class="table-actions">
                  <button
                    nz-button
                    nzType="default"
                    nzSize="small"
                    nzShape="circle"
                    (click)="editTable(option, $event)"
                    nz-tooltip
                    nzTooltipTitle="Edit Table"
                  >
                    <span nz-icon nzType="edit"></span>
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    nzSize="small"
                    nzShape="circle"
                    (click)="duplicateTable(option, $event)"
                    nz-tooltip
                    nzTooltipTitle="Duplicate Table"
                  >
                    <span nz-icon nzType="copy"></span>
                  </button>
                </div>
              </div>
            </nz-auto-option>
          </nz-autocomplete>
        </div> -->

        <div class="f-mood">
          <span class="build-time">v{{ appVersion }}</span>
          <div>
            <app-view-button
              text=" My Reports"
              type="primary"
              [icon]="'download'"
              [loading]="loading"
              [size]="'small'"
              (buttonClick)="reports()"
            ></app-view-button>
          </div>
          <div class="theme-toggler">
            <button nz-button nzType="default" class="mood" (click)="toggleTheme()">
              <span nz-icon [nzType]="isDarkMode ? 'bulb' : 'moon'"></span>
              {{ isDarkMode ? 'Light Mode' : 'Dark Mode' }}
            </button>
          </div>
          <div class="avatar" nz-dropdown [nzDropdownMenu]="userMenu" nzTrigger="click">
            <nz-avatar nzIcon="user" nzSize="default" class="header-avatar"></nz-avatar>
          </div>
        </div>
        <nz-dropdown-menu #userMenu="nzDropdownMenu">
          <div class="dropdown-container">
            <div class="dropdown-header">
              <nz-avatar nzIcon="user" nzSize="large" class="profile-avatar"></nz-avatar>
              <div class="user-details">
                <p class="user-name">{{ currentUser.fullname }}</p>
                <p class="user-email">{{ currentUser.username }}</p>
              </div>
            </div>
            <div class="dropdown-actions">
              <button
                nz-button
                nzType="default"
                nzSize="small"
                class="action-button"
                (click)="edit()"
              >
                <span nz-icon nzType="edit"></span>
                Edit Profile
              </button>
              <button
                nz-button
                nzType="default"
                nzSize="small"
                class="action-button logout-button"
                (click)="logout($event)"
              >
                <span nz-icon nzType="logout"></span>
                Log Out
              </button>
            </div>
          </div>
        </nz-dropdown-menu>
      </div>
    </nz-header>
    <nz-content>
      <!-- <nz-breadcrumb>
        <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs()">
          <a
            *ngIf="breadcrumb.link; else plain"
            [routerLink]="breadcrumb.link"
            >{{ breadcrumb.label }}</a
          >
          <ng-template #plain>{{ breadcrumb.label }}</ng-template>
        </nz-breadcrumb-item>
      </nz-breadcrumb> -->
      <div cdkScrollable class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
